import React from 'react'
import * as S from "./styles"
import {Row, Col} from "react-bootstrap"

export const Escolher = () => {
    return (
        <S.Container className="container">
            <h1>Por que escolher Gym Center?</h1>

            <Row>
                <Col xs={12} md={4}>
                    <h4>01.</h4>
                    <p><span>Equipamentos</span></p>
                    <p>Moderníssimos equipamentos de fitness e atividades que são um sucesso entre os clientes, contribuindo para tornar esta academia mais especial. </p>
                </Col>

                <Col xs={12} md={4}>
                    <h4>02.</h4>
                    <p><span>Localização</span></p>
                    <p>Com facilidade de acesso pelos mais diversos meios de transporte e próximo à integração Metrô na superfície Maria Angélica. </p>
                </Col>

                <Col xs={12} md={4}>
                    <h4>03.</h4>
                    <p><span>Equipe</span></p>
                    <p>Profissionais capacitados para oferecer todo o suporte que você precisa.  </p>
                </Col>
            </Row>
            
        </S.Container>
    )
}
